import {apolloClient} from '@/apollo'
import {
    ADD_NEW_PRODUCT,
    ADD_NEW_SHIPMENT,
    ADD_NEW_WAREHOUSE, MOVE_STOCK,
    UPDATE_ADJUSTED_STOCK, UPDATE_PRODUCT,
    UPDATE_SHIPMENT,
    UPDATE_WAREHOUSE
} from "@/gql/stock";

export const state = {
    loading: false,
    errors: [],
}
export const getters = {
    stockLoading: state => state.loading,
    stockErrors: state => state.errors
}
export const actions = {

    async addNewWarehouse({commit}, warehouseData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {warehouse}} = await apolloClient.mutate({
                mutation: ADD_NEW_WAREHOUSE,
                variables: warehouseData
            })
            return warehouse.warehouse
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateWarehouse({commit}, warehouseData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {warehouse}} = await apolloClient.mutate({
                mutation: UPDATE_WAREHOUSE,
                variables: warehouseData,
            })
            return warehouse.warehouse

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewShipment({commit}, shipmentData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {shipment}} = await apolloClient.mutate({
                mutation: ADD_NEW_SHIPMENT,
                variables: shipmentData
            })
            return shipment.shipment
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateShipment({commit}, shipmentData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {shipment}} = await apolloClient.mutate({
                mutation: UPDATE_SHIPMENT,
                variables: shipmentData,
            })
            return shipment.shipment

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async adjustStock({commit}, stockData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {stockAdjustment}} = await apolloClient.mutate({
                mutation: UPDATE_ADJUSTED_STOCK,
                variables: stockData
            })
            return stockAdjustment.stockAdjustment
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async moveStock({commit}, stockData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {moveStock}} = await apolloClient.mutate({
                mutation: MOVE_STOCK,
                variables: stockData
            })
            return moveStock
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },

    async addNewProduct({commit}, productData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {product}} = await apolloClient.mutate({
                mutation: ADD_NEW_PRODUCT,
                variables: productData
            })
            return product.product
        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
    async updateProduct({commit}, productData){
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try{
            let {data: {product}} = await apolloClient.mutate({
                mutation: UPDATE_PRODUCT,
                variables: productData,
            })
            return product.product

        }catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        }finally {
            commit('LOADING_FALSE')
        }
    },
}
export const mutations = {
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}


